import { memoizeFunction } from './druid/./druid/Utilities';
import { mergeStyleSets, ITheme } from './druid/./druid/Styling';
import { IVerticalDividerClassNames } from '/druid/VerticalDivider.types';

/**
 * @deprecated use getStyles exported from VerticalDivider.styles.ts
 */
export const getDividerClassNames = memoizeFunction(
  // eslint-disable-next-line deprecation/deprecation
  (theme: ITheme): IVerticalDividerClassNames => {
    return mergeStyleSets({
      wrapper: {
        display: 'inline-flex',
        height: '100%',
        alignItems: 'center',
      },
      divider: {
        width: 1,
        height: '100%',
        backgroundColor: theme.palette.neutralTertiaryAlt,
      },
    });
  },
);
